export const HIDDEN_CHECKOUT_PATH = "sesame";
export const RENEWAL_CHECKOUT_PATH = "renewal";

/** Route roots serving the plain, product-level checkout — the public sales link. */
const MAIN_CHECKOUT_ROOTS = ["c", "cart", "embed"];

/** `en`, `pl`, but also `pt-BR` / `zh-Hans` should Next ever be configured with them. */
const LOCALE_SEGMENT = /^[a-z]{2}(-[A-Za-z]{2,4})?$/;

/**
 * Tells whether a pathname is the product's *main* checkout, i.e. the public link that
 * `AutomationSettings.disableMainCheckoutSales` closes (TRE-1787).
 *
 * Deliberately excluded, so the kill-switch never locks out people who are not buying from
 * that link: renewals (`/c/renewal/...`), the hidden sales-rep checkout (`/c/sesame/...`),
 * variant carts (`/s/`, `/step/`), funnels (`/o/`, `/oferta/`) and the dedicated offer pages.
 */
export const isMainCheckoutPath = (pathname: string | null | undefined): boolean => {
  const segments = (pathname ?? "").split("/").filter(Boolean);

  // Non-default locales are prefixed by Next (`/en/c/<slug>`). No checkout root looks like a
  // locale code, so a leading one can only be the prefix.
  if (segments[0] && LOCALE_SEGMENT.test(segments[0])) {
    segments.shift();
  }

  const [root, second, third] = segments;

  if (!root || !MAIN_CHECKOUT_ROOTS.includes(root)) {
    return false;
  }

  // `renewal` / `sesame` only mean the special sub-route when a product follows them —
  // `/cart/renewal` on its own is a product whose slug happens to be "renewal".
  const isSpecialSubRoute = Boolean(third) && (second === RENEWAL_CHECKOUT_PATH || second === HIDDEN_CHECKOUT_PATH);

  return !isSpecialSubRoute;
};
